<template>
  <div class="main-container">
    <NavbarComponent :mobileView="true" :hide-button="!showContent" />
    <div v-if="showContent">
      <WelcomeUser v-if="showContent" :mobileView="true" />
      <StatusBar />
      <b-card no-body>
        <b-tabs card class="content-bg">
          <b-tab
            v-for="tab in tabs.filter((tab) => tab.show)"
            :key="tab.id"
            :title="tab.title"
            :active="tab.active"
            @click="tabChanged(tab.id)">
            <template #title>
              {{ tab.title }}
            </template>
            <component :is="tab.component" :mobileView="true" />
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <div v-if="!showContent">
      <StatusBar />
      <About :errorMessage="errorMessage" :mobileView="true" />
    </div>
  </div>
</template>

<script>
// import Services from '../services/main.service.vue'
import NavbarComponent from '../components/Navbar.vue'
import About from '../components/About.vue'
import WelcomeUser from '../components/WelcomeUser.vue'
import StatusBar from '../components/StatusBar.vue'
import HolidayLogs from '../components/logs-components/Holiday/Main.vue'
import ExpenseLogs from '../components/logs-components/ExpenseLogs.vue'
import StaffingLogs from '../components/logs-components/StaffingLogs.vue'
import TimeLogs from '../components/logs-components/TimeLogs.vue'

export default {
  name: 'HomePage',
  components: {
    NavbarComponent,
    About,
    WelcomeUser,
    StatusBar,
    HolidayLogs,
    ExpenseLogs,
    TimeLogs,
    StaffingLogs
  },
  data() {
    return {
      errorMessage: '',
      showContent: false,
      env:
        this?.$store?.getters?.appEnv ??
        process?.env?.VUE_APP_ENV ??
        'production',
      notifSent: [],
      tabs: [
        {
          id: 'tab_expenses',
          component: 'expense-logs',
          title: 'Expenses',
          icon: 'wallet2',
          roles: { rolesExcluded: ['ftintern, ptintern'] },
          active: false,
          show: false
        },
        {
          id: 'tab_holidays',
          component: 'holiday-logs',
          icon: 'emoji-sunglasses',
          title: 'Leave',
          roles: { rolesExcluded: ['ftintern, ptintern'] },
          active: false,
          show: false
        },
        // {
        //   id: 'tab_timelogs',
        //   component: 'time-logs',
        //   icon: 'clock',
        //   title: 'Timesheet',
        //   roles: { rolesExcluded: ['ftintern, ptintern'] },
        //   active: false,
        //   show: false
        // },
        {
          id: 'tab_staffing_logs',
          component: 'staffing-logs',
          icon: 'calendar3',
          title: 'Staffing',
          roles: {},
          active: false,
          show: false
        }
      ]
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    UserData() {
      return this.Store.userAuth
    },
    IsAuthenticated() {
      return this.UserData.authenticated
    }
  },
  mounted() {
    this.$root.$on('service-status', (isAvailable) => {
      this.toastNotif = null
      setTimeout(() => {
        if (!isAvailable) {
          this.fireNetworkNotif(false)
        } else {
          this.fireNetworkNotif(true)
        }
      }, 500)
    })
    this.$root.$on('network-status', (isOnine, errMessage) => {
      this.toastNotif = null
      setTimeout(() => {
        if (!isOnine) {
          this.fireNetworkNotif(false, errMessage)
        }
      }, 500)
    })
    this.$root.$on('fireLoginNotif', () => {
      if (!this.notifSent.includes('fireLoginNotif')) {
        setTimeout(() => {
          this.fireLoginNotif(false)
        }, 2000)
      }
    })
    this.$root.$on('fire403Notif', () => {
      setTimeout(() => {
        this.fire403Notif(false)
      }, 2000)
    })
  },
  methods: {
    userLoaded(user) {
      try {
        this.showContent = user?.authenticated ?? false
        if (user) {
          const userTabs = user?.details?.app?.tabsToShow ?? []
          let tabActive = false
          this.tabs = this.tabs.map((tab) => {
            const tabLabel = tab.id.split('_').splice(1).join('_')
            tab.show = userTabs.includes(tabLabel) ?? false
            if (tab.show && !tabActive) {
              tabActive = true
              tab.active = true
              setTimeout(() => {
                this.tabChanged(tab.id)
              }, 2000)
            }
            return tab
          })
        }
      } catch (exception) {
        console.log(exception)
      }
    },
    tabChanged(tabId) {
      this.$root.$emit(`parent_${tabId}_selected`)
      // check user is still logged in
      // Services.Users.fetchCurrentUser()
      //   .then(({ status }) => {
      //     if (status === 200) {
      //       this.$root.$emit(`parent_${tabId}_selected`)
      //     } else {
      //       this.$root.$emit('user-signed-out')
      //     }
      //   })
      //   .catch(() => {
      //     this.$root.$emit('user-signed-out')
      //   })
    },
    fireNetworkNotif(
      success = true,
      errMessage = 'Timesheet service is not available right now. Please try again later.'
    ) {
      // console.log({ notifSent: this.notifSent })
      if (!this.notifSent.includes(`fireNetworkNotif:${success}`)) {
        this.notifSent.push(`fireNetworkNotif:${success}`)
        this.$toasted[success ? 'success' : 'error'](
          success ? 'Timesheet service is available!' : errMessage
        ).goAway(success ? 2000 : 20000)
      }
    },
    fireLoginNotif() {
      if (this.showContent) {
        return
      }
      this.notifSent.push('fireLoginNotif')
      return this.$toasted
        .info('Please sign-in using your Candesic account.')
        .goAway(1500)
    },
    fire403Notif() {
      this.errorMessage =
        'Your account is not active, Please ask administrator to activate it.'
      this.notifSent.push('fire403Notif')
      return this.$toasted.info(this.errorMessage).goAway(1500)
    },
    isPrd() {
      return ['staging', 'development'].indexOf(this.env) === -1
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    }
  },
  watch: {
    UserData: {
      handler: 'userLoaded',
      deep: true,
      immediate: true
    }
  }
}
</script>

<style>
.main-container {
  min-height: calc(100vh - 100px) !important;
}
.card {
  background: rgba(245, 244, 239, 0.9) !important;
  border-radius: 0 !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(245, 244, 239, 0.4) !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  transition: all 0.3s ease;
}

.card-header {
  border-radius: 0 !important;
  background: rgba(245, 244, 239, 0.95) !important;
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
  padding: 0.75rem 1.25rem !important;
}

ul.nav-tabs {
  border-bottom: none !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center !important;
  gap: 6px;
  margin-bottom: 0 !important;
}

ul.nav-tabs > .nav-item {
  margin-bottom: 0 !important;
}

ul.nav-tabs > .nav-item .nav-link {
  font-size: 0.95rem !important;
  font-weight: 500 !important;
  color: #4b5563 !important;
  margin: 0 !important;
  padding: 0.6rem 1.1rem !important;
  border-radius: 8px !important;
  border: 1px solid transparent !important;
  background: transparent !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  vertical-align: middle !important;
  gap: 8px !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

ul.nav-tabs > .nav-item .nav-link svg,
ul.nav-tabs > .nav-item .nav-link i,
ul.nav-tabs > .nav-item .nav-link .bi {
  margin: 0 !important;
  vertical-align: middle !important;
}

ul.nav-tabs > .nav-item .nav-link:hover {
  color: #111827 !important;
  background-color: rgba(0, 115, 190, 0.05) !important;
  border-color: rgba(0, 115, 190, 0.1) !important;
}

ul.nav-tabs > .nav-item .nav-link.active {
  color: #ffffff !important;
  font-weight: 600 !important;
  background: linear-gradient(135deg, #0073be 0%, #1d9ce5 100%) !important;
  border-color: #0073be !important;
  box-shadow: 0 4px 12px rgba(0, 115, 190, 0.25) !important;
}

ul.nav-pills > .nav-item .nav-link {
  font-size: 0.95rem !important;
  font-weight: 500 !important;
  color: #4b5563 !important;
  padding: 0.5rem 1rem !important;
  border-radius: 6px !important;
  transition: all 0.2s ease !important;
}

ul.nav-pills > .nav-item .nav-link:hover {
  background-color: rgba(0, 115, 190, 0.08) !important;
  color: #0073be !important;
}

ul.nav-pills > .nav-item .nav-link.active {
  background-color: #0073be !important;
  color: #fff !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 10px rgba(0, 115, 190, 0.2) !important;
}
</style>
